module.exports = __webpack_public_path__ + "static/salon-pasajeros---asientos-15b6674e88e54efd21596f5cfb9ff6fa.jpg";